<template>
  <div v-if="canUpdateFunctions" class="mt-4">
    <Divider />
    <h3 class="mb-4">{{ t('userFunctions.label') }}</h3>

    <MultiSelectField
      name="functions"
      :label="t('userFunctions.label')"
      :options="functionOptions"
      :disabled="disabled || !canUpdateFunctions"
      :placeholder="t('selectFunctions')"
    />

    <Divider />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Divider from '@/components/Divider.vue';
import MultiSelectField from '@/components/MultiSelectField.vue';
import { useField } from 'vee-validate';
import { useAbility } from '@casl/vue';
import { subject } from '@casl/ability';
import { UserFunction } from '@carvia/ros-client-types';

const props = defineProps<{
  user?: {
    functions?: string[];
  };
  disabled?: boolean;
}>();

const { t } = useI18n();
const ability = useAbility();

const functionOptions = computed(() =>
  Object.values(UserFunction).map((func) => ({
    label: t(`userFunctions.${func}`),
    value: func,
  })),
);

const canUpdateFunctions = computed(() => {
  if (!props.user) return false;
  return ability.can('update', subject('User', props.user), 'functions');
});

// Use vee-validate field to handle the multiselect
useField('functions', undefined, {
  initialValue: props.user?.functions || [],
});
</script>

<i18n lang="json">
{
  "en": {
    "selectFunctions": "Select functions..."
  },
  "de": {
    "selectFunctions": "Funktionen auswählen..."
  },
  "es": {
    "selectFunctions": "Seleccionar funciones…"
  }
}
</i18n>
